import { ISelectOption } from "~/shared/ui/Fields/types";
import {
  APPEAL_STATUS,
  MALUS_STATUS,
  RESOLUTION_STATUS,
} from "~/entity/Appeals/model/schema";
import { TFunction } from "i18next";

export const getMalusStatus = (t: TFunction): ISelectOption[] =>
  Object.keys(MALUS_STATUS).map((key) => ({
    label: t(`appeal.malusStatusSelect.${key}`),
    value: key,
  }));
export const getAppealStatus = (t: TFunction): ISelectOption[] =>
  Object.keys(APPEAL_STATUS).map((key) => ({
    label: t(`appeal.appealStatus.${key}`),
    value: key,
  }));
export const getResolutionStatus = (t: TFunction): ISelectOption[] =>
  Object.keys(RESOLUTION_STATUS).map((key) => ({
    label: t(`appeal.resolutionStatus.${key}`),
    value: key,
  }));
